import { render, staticRenderFns } from "./generated-codes.vue?vue&type=template&id=20e05890&scoped=true"
import script from "./generated-codes.vue?vue&type=script&lang=js"
export * from "./generated-codes.vue?vue&type=script&lang=js"
import style0 from "./generated-codes.vue?vue&type=style&index=0&id=20e05890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e05890",
  null
  
)

export default component.exports